import { render } from "./ModalOnboarding.vue?vue&type=template&id=376c8464&scoped=true&ts=true"
import script from "./ModalOnboarding.vue?vue&type=script&lang=ts"
export * from "./ModalOnboarding.vue?vue&type=script&lang=ts"

import "./ModalOnboarding.vue?vue&type=style&index=0&id=376c8464&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-376c8464"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QImg,QCardActions,QBtn});
